import flatten from 'lodash/flatten';
import flattenDeep from 'lodash/flattenDeep';
import isEmpty from 'lodash/isEmpty';

const BundleImages = (product) => {
  let bundleGames = [];
  if (product.bundles && (product.display_type === 'game' || product.template_type !== 'original')) {
    bundleGames = product.bundles.map(bundle => bundle.games);
  }

  const bundleGamesF = flatten(bundleGames);
  let bundleImages = [];
  if (!isEmpty(bundleGamesF)) {
    bundleImages = bundleGamesF.map(bundle => bundle.img);
  }

  bundleImages = flattenDeep(bundleImages);

  return (bundleImages);
};

export default BundleImages;
